import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { createUsers, fetchRoles } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import { Roles } from '../roles/RolesColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { Users } from './UsersColumns';
import axios from 'axios';
import SpinnerForm from '../spinnner/SpinnerForm';

const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showAddUserDrawer: boolean;
    setShowAddUserDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getUsers: any
}
const AddUserDrawer: React.FC<ProductsDrawerProps> = ({ showAddUserDrawer, setShowAddUserDrawer, getUsers }) => {
    const onCLose = () => setShowAddUserDrawer(false)
    const [submitting, setSubmitting] = useState(false)
    const [rolesDisplay, setRolesDisplay] = useState<Roles[]>([])
    const [rolesOptions, setRolesOptions] = useState([])
    const [loadingRoles, setLoadingRoles] = useState<boolean>(true)
    const [form] = Form.useForm()
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate()


    const getRoles = () => {
        let isMounted = true;
        setLoadingRoles(true)
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/roles', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Roles[]) => {
                if (isMounted) {
                    setRolesDisplay(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoadingRoles(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getRoles()
    }, [])


    useEffect(() => {
        const updatedRolesOptions: any = rolesDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setRolesOptions(updatedRolesOptions);
    }, [rolesDisplay])


    const filterRolesOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }


    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const onFinish = (user: any) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/users', user, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "user successfully added",
                    `${user.email} was added to the system`,
                    'topRight'
                )
            }
            getUsers()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2));
    }


    return (
        <>
            <Drawer
                title="Add user"
                width={720}
                onClose={onCLose}
                open={showAddUserDrawer}
                bodyStyle={{ paddingBottom: 80 }}
                style={{
                    backgroundColor: 'white',
                    transition: 'transform 0.3s ease, opacity 0.3s ease'
                }}
                maskStyle={{
                    transition: 'opacity 0.3s ease'
                }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={onCLose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                    </div>
                }
            >
                {(loadingRoles) ? (
                    <div>
                        <SpinnerForm />
                    </div>
                )
                    : (
                        <Form layout="vertical"
                            onFinishFailed={onFinishFailed}
                            onFinish={onFinish}
                            form={form}
                            hideRequiredMark>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="name"
                                        label="Name"
                                        rules={[{ required: true, message: 'Please enter name' }]}
                                    >
                                        <Input
                                            placeholder="Please enter name"
                                            className='focus:border-green-500 hover:border-green-500'
                                            autoComplete="off" 
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="email"
                                        label="Email"
                                        rules={[{ required: true, message: 'Please enter email' }]}
                                    >
                                        <Input
                                            placeholder="Please enter email"
                                            className='focus:border-green-500 hover:border-green-500'
                                            autoComplete="off" 
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item
                                        name="password"
                                        label="Password"
                                        rules={[{ required: true, message: 'Please enter password' }]}
                                    >
                                        <Input
                                            placeholder="Please enter password"
                                            className='focus:border-green-500 hover:border-green-500'
                                            autoComplete="off" 
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="role_id"
                                        label="Role"
                                        rules={[{ required: true, message: 'Please slect product name' }]}
                                    >
                                        <Select
                                            placeholder="Please select product name"
                                            showSearch
                                            style={{ borderColor: 'black' }}
                                            filterOption={filterRolesOptions}
                                        >
                                            {rolesOptions.map((option: any) => (
                                                <Option key={option.value} value={option.value}>{option.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                                            Submit
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row>

                                {submitting && <Spin indicator={antIcon} />}
                            </Row>


                        </Form>
                    )}

            </Drawer>
        </>
    )
}

export default AddUserDrawer;


